<template>
	<div class="container__formdropdown">
		<div
			:class="['container__formdropdown__backdrop', { 'dropdown-ativo': dropdownAtivo }]"
			@click="dropdownAtivo = false"
		/>
		<div
			ref="ref__dropdown__button"
			class="container__formdropdown__button"
		>
			<div
				:id="`dropdown__button__${uniqueRef}`"
				ref="teste4321"
				style="
					padding: 0 0.5rem;
					cursor: pointer;
					font-size: 0.875rem;
					color: rgb(var(--color-primary));
				"
				@click="dropdownAtivo = !dropdownAtivo"
				v-html="label"
			/>
			<div
				:id="`dropdown__button__ativo__${uniqueRef}`"
				v-closable="{ exclude: ['ref__dropdown__button'], handler: 'fecharFormDropdown' }"
				:class="['container__formdropdown__form', { 'dropdown-ativo': dropdownAtivo }]"
			>
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
	props: {
		label: { type: String, required: true },
	},
	data() {
		return {
			dropdownAtivo: false,
			mutationObserver: undefined,
		}
	},
	computed: {
		uniqueRef() {
			return uuidv4()
		},
	},
	mounted() {
		this.mutationObserver = new MutationObserver(this.alteracaoNoTamanho)
		const config = { attributes: true, childList: true, subtree: true }
		this.mutationObserver.observe(
			document.getElementById(`dropdown__button__${this.uniqueRef}`),
			config,
		)
	},
	beforeDestroy() {
		this.mutationObserver.disconnect()
	},
	methods: {
		fecharFormDropdown() {
			this.dropdownAtivo = false
		},
		alteracaoNoTamanho(e) {
			if (window.innerWidth > 992) {
				const distanciaDropdownAtivo = (e[0].target.clientHeight + 11) / 16
				const dropdownAtivoElemento = document.getElementById(
					`dropdown__button__ativo__${this.uniqueRef}`,
				)
				dropdownAtivoElemento.style.top = `${distanciaDropdownAtivo}rem`
			}
		},
	},
}
</script>

<style scoped>
.container__formdropdown__backdrop {
	background-color: rgba(0, 0, 0, 0.3);
	display: none;
}

.container__formdropdown__backdrop.dropdown-ativo {
	display: block;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 50;
}

.container__formdropdown__button {
	position: relative;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	user-select: none;
	border: 1px solid rgb(var(--color-primary));
}

.container__formdropdown__form {
	position: fixed;
	right: 0;
	left: 0;
	top: -100vh;
	width: 100%;
	padding: 0.5rem;
	overflow-y: auto;
	max-height: 50vh;
}

.container__formdropdown__form.dropdown-ativo {
	position: fixed;
	top: unset;
	bottom: 0;
	height: auto;
	background-color: white;
	z-index: 60;
}

@media screen and (min-width: 992px) {
	.container__formdropdown__backdrop.dropdown-ativo {
		display: none;
	}

	.container__formdropdown__form {
		display: none;
		max-height: 80vh;
		border: 1px solid rgb(var(--color-primary));
	}

	.container__formdropdown__form.dropdown-ativo {
		display: block;
		position: absolute;
		top: 2rem;
		bottom: unset;
		left: unset;
		min-width: 20rem;
	}

	.container__formdropdown__form.dropdown-ativo::after {
		content: '';
		position: absolute;
		right: 1.6rem;
		top: -1.1rem;
		border-bottom: 10px solid white;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-top: 10px solid transparent;
	}
}
</style>
